<!--系统管理页面弹窗组件  :rules="rules"-->
<template>
  <div>
    <el-form
      :disabled="!['编辑', '派发'].includes(showTitle)"
      :inline="true"
      :model="serverObj"
      :rules="rules"
      ref="ruleForm"
      label-width="140px"
      class="demo-ruleForm"
    >
      <div style="height: 12px; margin-top: 30px; color: #169bd5">客户信息</div>
      <el-divider></el-divider>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="客户姓名：" prop="customerName">
            <el-input
              v-model="serverObj.customerName"
              size="medium"
              :disabled="showTitle == '查看'"
              @click.native="inputClickName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工单类型：" prop="customerType">
            <el-select
              style="width: 100%"
              v-model="serverObj.customerType"
              placeholder="请选择"
              size="medium"
              :disabled="showTitle === '查看'"
            >
              <el-option label="商业服务工单" value="1"></el-option>
              <el-option label="民政服务工单" value="6"></el-option>
              <el-option label="老干服务工单" value="4"></el-option>
              <el-option label="残联服务工单" value="3"></el-option>
              <el-option label="文明办服务工单" value="10"></el-option>
              <el-option label="退役军人服务工单" value="14"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="联系人：" prop="customerName">
            <el-input
              v-model="serverObj.customerName"
              size="medium"
              :disabled="showTitle === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式：" prop="customerphone">
            <el-input
              v-model="serverObj.customerphone"
              size="medium"
              :disabled="showTitle === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20" class="addso">
          <el-form-item label="联系地址：" prop="address" style='width:80%'>
            <el-input
              v-model="serverObj.address"
              size="medium"
              :disabled="showTitle === '查看'"
              style='width:100%'
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            label="联系方式二："
            prop="otherTelephone"
            v-show="qtlxfs"
          >
            <el-input
              v-model="serverObj.otherservePersonName"
              size="medium"
              :disabled="showTitle === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系地址：" prop="familyAddress" v-show="qtlxfs">
            <el-input
              v-model="serverObj.familyAddress"
              size="medium"
              :disabled="showTitle === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="height: 12px; margin-top: 30px; color: #169bd5">服务工单</div>
      <el-divider></el-divider>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="套餐类型：" prop="taocanleixing">
            <el-select
              v-model="serverObj.ensure"
              placeholder="请选择"
              style="width: 100%"
              size="medium"
              :disabled="showTitle === '查看'"
            >
              <el-option
                v-for="item in ensureList"
                :key="item.id"
                :label="item.mealType"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务时长：" prop="period">
            <el-input v-model="serverObj.period" size="medium" disabled
              ><i slot="suffix">分钟</i></el-input
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="服务价格：">
            <el-input v-model="serverObj.price" size="medium" disabled
              ><i slot="suffix">元</i></el-input
            >
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务类别：" prop="servetypename">
            <!-- <el-input
              v-model="serverObj.servetypename"
              :disabled="showTitle === '查看' || showTitle === '回访'"
              style="width: 205px"
            ></el-input> -->
            <el-select
              v-model="serverObj.servetypename"
              placeholder="请选择"
              style="width: 100%"
              size="medium"
              multiple
              collapse-tags
              :disabled="showTitle === '查看' || showTitle === '回访'"
              @change='changeType'
            >
              <el-option
                v-for="item in servetypeList"
                :key="item.id"
                :label="item.serviceTypeName"
                :value="item.serviceTypeName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="计划时间：" prop="sertime">
        <el-date-picker
          v-model="serverObj.sertime"
          type="datetime"
          :disabled="showTitle === '查看'"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="计划时间"
          size="medium"
          style="width: 205px"
        >
        </el-date-picker>
      </el-form-item>
      <el-row :gutter="10">
        <el-form-item label="服务项目：" prop="serveproductName">
          <el-checkbox-group
            v-model="serveproductName"
            @change="groupCheck"
            :disabled="showTitle === '查看'"
          >
            <el-checkbox
              v-for="data in tableProject"
              :label="data.id"
              :key="data.id"
            >
              {{ data.serviceProductName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-row>
      <el-form-item label="其他说明：" prop="produce" class="formTextarea">
        <el-input
          v-model="serverObj.otherDesc"
          size="medium"
          type="textarea"
          :disabled="showTitle === '查看'"
        ></el-input>
      </el-form-item>
      <div style="height: 12px; margin-top: 30px; color: #169bd5">服务人员</div>
      <el-divider></el-divider>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="机构：" prop="servestationName">
            <el-input
              v-model="serverObj.servestationName"
              @click.native="inputClickStation"
              size="medium"
              :disabled="showTitle === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="站点类型：" prop="statType">
            <el-select
              style="width: 100%"
              v-model="serverObj.statType"
              placeholder="请选择"
              size="medium"
              :disabled="showTitle === '查看'"
            >
              <el-option label="居家养老机构" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="服务人员：" prop="servePersonName">
            <el-input
              v-model="serverObj.servePersonName"
              size="medium"
              :disabled="showTitle === '查看'"
              @click.native="serveName1Fn(1)"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式：" prop="servePersonPhone">
            <el-input
              v-model="serverObj.servePersonPhone"
              size="medium"
              :disabled="showTitle === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="陪同人员：" prop="otherservePersonName">
            <el-input
              v-model="serverObj.otherservePersonName"
              size="medium"
              @click.native="serveName1Fn(2)"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="陪同人员联系方式：" prop="otherservePersonPhone">
            <el-input
              v-model="serverObj.otherservePersonPhone"
              size="medium"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="是否有加盟商：" prop="franchisee">
            <el-radio-group
              :disabled="showTitle === '查看'"
              v-model="serverObj.franchisee"
              @change="isFranchisee"
            >
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="加盟商：" prop="jiamengName" v-show="franchisee">
            <el-input
              v-model="serverObj.jiamengName"
              size="medium"
              :disabled="showTitle === '查看'"
              @click.native="servestationNameFn"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="是否有从属服务人员：" prop="otherServePerson">
            <el-radio-group
              :disabled="showTitle === '查看'"
              v-model="serverObj.otherServePerson"
              @change="isOtherServePerson"
            >
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="服务人员："
            prop="otherservePersonName"
            v-show="otherServePerson"
            @click.native="serveNameFn"
          >
            <el-input
              v-model="serverObj.otherservePersonName"
              size="medium"
              :disabled="showTitle === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="是否有志愿者：" prop="volunteer">
            <el-radio-group
              :disabled="showTitle === '查看'"
              v-model="serverObj.volunteer"
              @change="isVolunteer"
            >
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="志愿者："
            prop="otherReturnContent"
            v-show="volunteer"
          >
            <el-input
              v-model="serverObj.otherReturnContent"
              size="medium"
              :disabled="showTitle === '查看'"
              @click.native="voluteerNameFn"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
    </el-form>
    <!-- 客户列表 -->
    <CustomerList
      :show-status.sync="showAddStatus"
      @send="sendCustomerName"
      ref="Customer"
    ></CustomerList>
    <!-- 服务种类 -->
    <!--    <ChanPinList-->
    <!--      ref='ChanPinList'-->
    <!--      :service-type-id='serverObj.servetypename'-->
    <!--      @send='productNames'-->
    <!--      :show-chanpin.sync='showChanpin'-->
    <!--    ></ChanPinList>-->
    <!-- 机构 -->
    <ServeStation
      ref="ServeStation"
      :first-type="serverObj.servestationName"
      :show-station.sync="showStation"
      @send="sendServestation"
    ></ServeStation>

    <!-- 加盟商 -->
    <el-dialog
      title="加盟商"
      :visible.sync="showSallianceBusiness"
      width="30%"
      append-to-body
      :before-close="onJMSClose"
      :close-on-click-modal="false"
    >
      <div class="cu-title1">
        <div class="cu-title2">
          <div>加盟商</div>
          <el-input size="medium" v-model="franchiseeName"></el-input>
        </div>
        <div class="cu-title3">
          <el-button type="primary" size="medium" @click="getJMSList"
            >查询
          </el-button>
        </div>
      </div>
      <div style="margin: 20px 0">
        <el-table
          class="form-table"
          :data="jmTableData"
          border
          highlight-current-row
          @current-change="getJMS"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            fixed
            type="index"
            align="center"
            label="序号"
            width="60"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="franchiseeName"
            label="名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="address"
            label="地址"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="jmSizeChange"
          @current-change="jmCurrentChange"
          :page-sizes="[5, 10, 15, 20]"
          :current-page="query.pageNo"
          :page-size="query.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 15px;
        "
      >
        <el-button type="primary" @click="jmSend">保存</el-button>
        <el-button @click="onJMSClose">取 消</el-button>
      </div>
    </el-dialog>

    <!--从属服务人员 -->
    <el-dialog
      title="从属服务人员"
      :visible.sync="showServeName"
      width="30%"
      append-to-body
      :before-close="showServeNameClose"
      :close-on-click-modal="false"
    >
      <div class="cu-title1">
        <div class="cu-title2">
          <div>服务人员：</div>
          <el-input size="medium" v-model="serveName"></el-input>
        </div>
        <div class="cu-title3">
          <el-button type="primary" size="medium" @click="getServeName1DataList"
            >查询
          </el-button>
        </div>
      </div>
      <div style="margin: 20px 0">
        <el-table
          class="form-table"
          :data="serveNameTableData"
          stripe
          tooltip-effect="dark"
          style="width: 100%"
          highlight-current-row
          @current-change="getServePersonName"
        >
          <el-table-column
            align="center"
            fixed
            type="index"
            label="序号"
            width="50"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="servePersonName"
            label="名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="serveNamePhone"
            label="手机号"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="serveNameSizeChange"
          @current-change="serveNameCurrentChange"
          :page-sizes="[5, 10, 15, 20]"
          :current-page="query.pageNo"
          :page-size="query.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
      <div style="display: flex; align-items: center; justify-content: center">
        <el-button type="primary" @click="serveNameSend">保存 </el-button>
        <el-button @click="showServeNameClose">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 志愿者 -->
    <el-dialog
      title="志愿者"
      :visible.sync="showVolunteer"
      width="30%"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="cu-title1">
        <div class="cu-title2">
          <div>志愿者：</div>
          <el-input size="medium" v-model="volunteerName"></el-input>
        </div>
        <div class="cu-title3">
          <el-button type="primary" size="medium" @click="getDataList"
            >查询
          </el-button>
        </div>
      </div>
      <div style="margin: 20px 0">
        <el-table
          class="form-table"
          :data="volunteerTableData"
          @selection-change="volunteerSelectionChange"
          stripe
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column fixed type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column prop="volunteer" label="名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="volunteerPhone"
            label="手机号"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="volunteerSizeChange"
          @current-change="volunteerCurrentChange"
          :page-sizes="[5, 10, 15, 20]"
          :current-page="query.pageNo"
          :page-size="query.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
      <span style="margin-left: 200px">
        <el-button type="primary" @click="volunteerSend">保存</el-button>
        <el-button @click="showVolunteer = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 服务人员 -->
    <el-dialog
      title="服务人员"
      :visible.sync="showServeName1"
      width="500"
      append-to-body
      :before-close="showServeName1Close"
      :close-on-click-modal="false"
    >
      <div class="cu-title1">
        <div class="cu-title2">
          <div>服务人员：</div>
          <el-input size="medium" v-model="personName"></el-input>
        </div>
        <div class="cu-title3">
          <el-button type="primary" size="medium" @click="getServeName1DataList"
            >查询
          </el-button>
        </div>
      </div>
      <div style="margin: 20px 0">
        <el-table
          class="form-table"
          :data="serveName1TableData"
          border
          highlight-current-row
          @current-change="getServePersonName"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            fixed
            type="index"
            label="序号"
            width="50"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="personName"
            label="名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="personPhone"
            label="手机号"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="serveName1SizeChange"
          @current-change="serveName1CurrentChange"
          :page-sizes="[5, 10, 15, 20]"
          :current-page="query.pageNo"
          :page-size="query.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 15px;
        "
      >
        <el-button type="primary" @click="serveName1Send">保存 </el-button>
        <el-button @click="showServeName1Close">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/utils/request.js"
import CustomerList from "../component/customerList.vue"
import ChanPinList from "../component/chanPinList.vue"
import ServeStation from "../component/serveStation.vue"

export default {
  components: {
    CustomerList,
    ChanPinList,
    ServeStation,
  },
  name: "CallbackVisitDialog",
  props: {
    showVisit: {
      type: Boolean,
      default: false,
    },
    showTitle: {
      type: String,
      default: "",
    },
    orderInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      selectType:1,
      changeContent: [],
      datechangelist: [],
      checkList: [],
      showCard: false,
      volunteer: false,
      franchisee: false,
      otherServePerson: false,
      qtlxfs: false,
      imageUrl: "",
      radio: "",
      showAddStatus: false,
      showChanpin: false,
      showStation: false,
      showSallianceBusiness: false,
      jiamengTemp: "",
      showServeName: false,
      showServeName1: false,
      personName: "",
      showVolunteer: false,
      franchiseeName: "",
      tempJiameng: "",
      rules: {
        name: [
          {
            required: true,
            message: "请输入客户名称",
            trigger: "input",
          },
        ],
        customerType: [
          {
            required: true,
            message: "请选择工单类型",
            trigger: "blur",
          },
        ],
        contactrName: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur",
          },
        ],
        erviceType: [
          {
            required: true,
            message: "请输入套餐类型",
            trigger: "blur",
          },
        ],
        serviceType: [
          {
            required: false,
            message: "请选择服务种类",
            trigger: "blur",
          },
        ],
        serveproductName: [
          {
            required: false,
            message: "请选择服务项目",
            trigger: "input",
          },
        ],
        // sertime: [{ required: true, message: "该项必填", trigger: "blur" }],
        servestationName: [
          { required: true, message: "该项必填", trigger: "input" },
        ],
        // statType: [{required: true, message: "该项必填", trigger: "blur"}],
        // servePersonName: [
        //   {required: true, message: "该项必填", trigger: "input"},
        // ],
        // franchisee: [{required: true, message: "该项必填", trigger: "blur"}],
        // otherServePerson: [
        //   {required: true, message: "该项必填", trigger: "blur"},
        // ],
        // volunteer: [{required: true, message: "该项必填", trigger: "blur"}],
      },
      ensureList: [],
      serviceTypeList: [],
      serviceTypeId:[],
      servetypeList:[],
      serverObj: {
        servestationName: "",
        period: "",
        franchisee: null,
      },
      allianceBusiness: {},
      jmTableData: [
        {
          jiamengName: "合肥加盟商",
          jiamengAddress: "天路",
        },
      ],
      serveName: "",
      serveNameTableData: [],
      serveName1TableData: [],
      volunteerName: "",
      volunteerTableData: [],
      serveNameTemp: "",
      volunteerTemp: "",
      // 选择的服务人员
      servePersonData: undefined,
      totalCount: 0,
      query: {
        pageNo: 1,
        pageSize: 5,
      },
      serveproductName: [],
      tableProject: [],
    }
  },
  computed: {
    show() {
      return this.showVisit
    },
  },
  watch: {
    "orderInfo.customerName"(val) {
      if (
        (val && this.serverObj.states != "2") ||
        (val && this.showTitle == "回访" && this.serverObj.states == "2")
      ) {
       // this.getProjectList()
       // this.getEnsureList()
      }
    },
    orderInfo:{
      handler(newVal, oldVal){
        if (newVal) {
        // 设置站点类型
        newVal.statType = "0"
        this.serverObj = JSON.parse(JSON.stringify(newVal))
        this.serverObj.servetypename= this.serverObj.servetypename.split(',')
        this.getServiceTypeList()
        this.getEnsureList()
        if (this.serverObj.serveproductName != null) {
            let aff = this.serverObj.serveproductName.split(",")
            if (aff) {
              aff.forEach((item, index) => {
                if (item == "") {
                  aff.splice(index, 1)
                }
              })
            }
           setTimeout(()=>{
            this.getServeList()
            this.getProjectList(aff).then((res) => {
              this.tableProject = res
              console.log(this.tableProject,'this.tableProject')
              let idF = []
              if (aff.length > 0) {
                aff.forEach((item) => {
                  this.tableProject.forEach((it) => {
                    if (item == it.id) {
                      idF.push(it.id)
                    }
                  })
                })
                console.log(idF,'iid')
                this.serveproductName = idF
                this.$forceUpdate()
              } else {
                this.serveproductName = []
              }
            })
           },500)
          }
        // 如果存在加盟商
        if (this.serverObj.jiamengId) {
          this.serverObj.franchisee = "是"
          this.franchisee = true
        } else {
          this.serverObj.franchisee = "否"
          this.franchisee = false
        }
        // 如果存在从属服务人员
        if (this.serverObj.otherservePersonName) {
          this.serverObj.otherServePerson = "是"
          this.otherServePerson = true
        } else {
          this.serverObj.otherServePerson = "否"
          this.otherServePerson = false
        }
        // 如果存在志愿者
        if (this.serverObj.otherReturnContent) {
          this.serverObj.volunteer = "是"
          this.volunteer = true
        } else {
          this.serverObj.volunteer = "否"
          this.volunteer = false
        }
        // 处理勾选服务
        if (this.serverObj.changeContent) {
          this.changeContent = this.serverObj.changeContent
            .split(",")
            .filter((item) => item)
        }
        // 处理是否需要其他联系方式
        if (this.serverObj.familyPhone) {
          this.serverObj.otherTelephone = "1"
          this.qtlxfs = true
        } else {
          this.serverObj.otherTelephone = "2"
          this.qtlxfs = false
        }
      }
      },
      immediate: true,
			deep: true,
    },
    // orderInfo(newVal) {
    
    // },
  },
  created() {
    this.getDataList()
    
    this.serveproductName = []
  },
  methods: {
    getServeList(){
      request({
        url: "/jjyl/admin/type/info/findList1",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 9999,
          states: "1",
          customerId: this.serverObj.customer,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          const arr = res.content || []
          this.servetypeList=res.content
          if((this.showTitle != "新增") ||
          (this.showTitle == "查看")){
            this.serviceTypeId = this.servetypeList
           .filter(item => this.serverObj.servetypename.includes(item.serviceTypeName))
             .map(item => item.id)
          }
        }
      })
    },
    changeType(value){
      this.serviceTypeId = this.servetypeList
        .filter(item => value.includes(item.serviceTypeName))
        .map(item => item.id)
      this.getProjectList()
    },
    getProjectList(aff) {
      let self = this
      return new Promise((resolve, reject) => {
        let params = {
        pageNo: 1,
        pageSize: 99,
        status: "1",
        ids: aff,
        customerId: this.serverObj.customer,
        serviceTypeIds:this.serviceTypeId
      }
   //   console.log(this.showTitle,'this.showTitle')
      if(this.showTitle==='回访' || this.showTitle==='编辑' || this.showTitle==='作废' || this.showTitle==='撤回'){
        params.serviceStation=this.serverObj.serviceStation
      }
      request({
        url: "/jjyl/admin/product/info/findList1",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.tableProject = []
          if (this.showTitle != "查看") {
            this.tableProject = res.content.filter((item) => {
              return item.delFlag1 == "0"
            })
          } else if (this.showTitle == "查看") {
            if (aff) {
              res.content.forEach((item) => {
                  for (let i = 0; i < aff.length; i++) {
                    if (item.id == aff[i]) {
                      this.tableProject.push(item)
                    }
                  }
                })
            }
          }
          resolve(this.tableProject)
        } else {
          resolve([])
        }
      })
      })
    },
    groupCheck(val) {
      let _this = this
      console.log(val,this.serveproductName)
      // if (val.length > 0) {
      //   let newProjectList = []
      //   let serviceTypeName = []
      //   val.forEach((id) => {
      //     let serviceTypeList = this.tableProject.find((item) => item.id === id)
      //     newProjectList.push(serviceTypeList)
      //   })
      //   newProjectList = [...new Set(newProjectList)]
      //   newProjectList.forEach((el) => {
      //     let serviceTypeList = this.serviceTypeList.find(
      //       (item) => item.id === el.serviceTypeId
      //     )
      //     serviceTypeName.push(serviceTypeList.serviceTypeName)
      //   })
      //   this.serverObj.servetypename = Array.from(
      //     new Set(serviceTypeName)
      //   ).toString()
      //   console.log(this.serverObj.servetypename,'this.serverObj.servetypename')
      // } else {
      //   this.serverObj.servetypename = ""
      // }
      _this.$forceUpdate()
    },
    //获取所有的app勾选项
    async getmessageGetAll() {
      request({
        url: "/jjyl/changeContent/info/findChangeContent",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 50,
          belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.datechangelist = res.content.list || []
        }
      })
    },
    //客户姓名回显
    sendCustomerName(data) {
      this.serverObj.customerName = data
    },
    //服务项目回显
    productNames(data) {
      if (Array.isArray(data) && data.length > 0) {
        let serveproductName = ""
        let serveProduct = ""
        let produce = ""
        data.forEach((item, index) => {
          if (index === data.length - 1) {
            serveproductName = serveproductName + item.serviceProductName
            serveProduct = serveProduct + item.id
            // produce = produce + item.produce
          } else {
            serveproductName = serveproductName + item.serviceProductName + ","
            serveProduct = serveProduct + item.id + ","
            // produce = produce + item.produce + ','
          }
        })
        this.$set(this.serverObj, "serveproductName", serveproductName)
        this.$set(this.serverObj, "serveProduct", serveProduct)
        this.$set(this.serverObj, "produce", produce)
      }
    },
    // 显示机构弹框
    inputClickStation() {
      if (this.showTitle === "查看") return
      this.showStation = true
      this.$nextTick(() => {
        this.$refs.ServeStation && this.$refs.ServeStation.getDataList()
      })
    },
    // 机构弹框内点击保存
    sendServestation(data) {
      this.$set(this.serverObj, "servestationName", data.statName)
      this.$set(this.serverObj, "serveStation", data.id)
    },
    // 选择服务项目
    inputClickChanPin() {
      if (this.showTitle === "查看") return
      if (!this.serverObj.servetypename) {
        this.$message.error("请先选择服务种类")
        return
      }
      this.showChanpin = true
      this.$refs.ChanPinList && this.$refs.ChanPinList.getDataList()
    },

    // 获取服务种类
    getServiceTypeList() {
      request({
        url: "/jjyl/admin/type/info/findList1",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 999,
          customerId: this.serverObj.customer,
          status:'1'
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          const arr = res.content || []
          this.serviceTypeList = res.content
          // 过滤开启状态的服务种类
          // console.log()
          this.serviceTypeId = this.serviceTypeList
           .filter(item => this.serverObj.servetypename.includes(item.serviceTypeName))
             .map(item => item.id)
        } else {
          this.$message.error("获取服务种类失败")
        }
      })
    },
    // 获取套餐类型列表
    getEnsureList() {
      request({
        url: "/jjyl/admin/meal/info/findList1",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 9999,
          id: this.serverObj.ensure,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          const arr = res.content || []
          res.content.forEach((item) => {
            item.id = item.id + ""
          })
          this.ensureList = res.content
        }
      })
    },
    // 保存选中的加盟商
    getJMS(val) {
      if (val) {
        this.jiamengTemp = val
      }
    },
    //加盟商表格分页
    jmSizeChange(val) {
      this.query.pageSize = val
      this.getJMSList()
    },
    // 加盟商列表页数改变
    jmCurrentChange(val) {
      this.query.pageNo = val
    },
    // 加盟商弹框点击保存
    jmSend() {
      if (!this.jiamengTemp) {
        this.$message.error("请选择一个加盟商")
        return
      }
      this.showSallianceBusiness = false
      // this.$set(this.serverObj, "servestationNameJMS", this.jiamengTemp.franchiseeName)
      this.$set(this.serverObj, "jiamengName", this.jiamengTemp.franchiseeName)
      this.$set(this.serverObj, "jiamengId", this.jiamengTemp.id)
    },
    // 获取加盟商列表
    getJMSList() {
      request({
        url: "/jjyl/FranchiserController/info/findFranchiser",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          franchiseeName: this.franchiseeName,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.jmTableData = res.content.list || []
          this.totalCount = res.content.count || 0
        } else {
          this.$message.error("获取加盟商失败")
        }
      })
    },
    // 显示加盟商选择弹框
    servestationNameFn() {
      if (this.showTitle === "查看") return
      this.showSallianceBusiness = true
      this.getJMSList()
    },
    // 关闭加盟商弹框
    onJMSClose() {
      this.showSallianceBusiness = false
      this.franchiseeName = ""
      this.tempJiameng = ""
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
    },
    //志愿者
    voluteerNameFn() {
      if (this.showTitle === "查看") return
      this.showVolunteer = true
      this.getVoluteerList()
    },
    // 获取志愿者
    getVoluteerList() {
      request({
        url: "/jjyl/admin/volunteerArchive/info/list",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          gridId: this.$store.state.info.gridId,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.volunteerTableData = res.content.list || []
          this.totalCount = res.content.count || 0
        } else {
          this.$message.error("获取志愿者失败")
        }
      })
    },
    // 从属服务人员
    serveNameFn() {
      if (this.showTitle === "查看") return
      if (!this.serverObj.servestationId) {
        this.$message.error("请先选择机构")
        return
      }
      this.showServeName = true
      this.getServeNameDataList()
    },
    // 显示服务人员弹框
    serveName1Fn() {
      this.selectType=value
      if (this.showTitle === "查看") return
      if (!this.serverObj.serveStation) {
        this.$message.error("请先选择机构")
        return
      }
      this.showServeName1 = true
      this.getServeName1DataList()
    },
    // 服务人员页码切换
    serveName1SizeChange(val) {
      this.query.pageSize = val
      this.getServeName1DataList()
    },
    serveName1CurrentChange(val) {
      this.query.pageNo = val
      this.getServeName1DataList()
    },
    // 从属服务人员表格分页
    serveNameSizeChange(val) {
      this.query.pageSize = val
      this.getServeNameDataList()
    },
    serveNameCurrentChange(val) {
      this.query.pageNo = val
      this.getServeNameDataList()
    },
    //服务人员的表格获取
    getServeName1DataList() {
      request({
        url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          // 获取当前机构下面的服务人员
          serviceStationName: this.serverObj.servestationName,
          servePersonName: this.personName,
          serviceStationId: this.serverObj.serveStation,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.serveName1TableData = res.content.elderList.list || []
          this.totalCount = res.content.elderList.count || 0
          console.log(this.serveName1TableData, "xxx")
        } else {
          this.serveName1TableData = []
          this.totalCount = 0
          this.$message.error("该机构下暂无服务人员")
        }
      })
    },
    // 从属服务人员的表格获取
    getServeNameDataList() {
      request({
        url: "/jjyl/WebServeperson/info/findServeperson",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          // 获取当前机构下面的服务人员
          serviceStationName: this.serverObj.servestationName,
          servePersonName: this.serveName,
          belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.serveNameTableData = res.content.list || []
          this.totalCount = res.content.count || 0
        } else {
          this.serveNameTableData = []
          this.totalCount = 0
          this.$message.error("获取服务人员失败")
        }
      })
    },
    // 服务人员点击保存
    serveName1Send() {
      if(this.selectType==1){
        this.$set(
        this.serverObj,
        "servePersonName",
        this.servePersonData.personName
        )
        this.$set(
          this.serverObj,
          "servePersonPhone",
          this.servePersonData.personPhone
        )
        this.$set(this.serverObj, "servePersonID", this.servePersonData.id)
      }else{
        this.$set(
        this.serverObj,
        "otherservePersonName",
        this.servePersonData.personName
      )
      this.$set(
        this.serverObj,
        "otherservePersonPhone",
        this.servePersonData.personPhone
      )
      this.$set(this.serverObj, "otherservePersonID", this.servePersonData.id)
      }
      this.showServeName1Close()
    },
    // 从属服务人员点击保存
    serveNameSend() {
      this.$set(
        this.serverObj,
        "otherservePersonName",
        this.servePersonData.name
      )
      // this.$set(this.serverObj, 'servePersonPhone', this.servePersonData.mobilePhone)
      this.$set(this.serverObj, "otherservePersonID", this.servePersonData.ids)
      this.showServeNameClose()
    },
    // 服务人员弹框关闭
    showServeName1Close() {
      this.showServeName1 = false
      this.personName = ""
      this.serveName1TableData = []
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
    },
    // 从属服务人员弹框关闭
    showServeNameClose() {
      this.showServeName = false
      this.serveName = ""
      this.serveNameTableData = []
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
    },
    // 服务人员选择人员
    getServePersonName(val) {
      this.servePersonData = val
    },
    //志愿者
    volunteerSelectionChange(data) {
      this.volunteerTemp = data
    },
    //志愿者表格分页
    volunteerSizeChange(val) {
      this.query.pageSize = val
      this.getVoluteerList()
    },
    volunteerCurrentChange(val) {
      this.query.pageNo = val
      this.getVoluteerList()
    },
    volunteerSend() {
      if (this.volunteerTemp.length > 1) {
        this.$message.error("只能选择一个志愿者")
        return
      }
      this.showVolunteer = false
      if (this.volunteerTemp.length === 1) {
        // this.$set(this.serverObj, 'voluteerName', this.volunteerTemp[0].userName)
        // 代替志愿者字段
        this.$set(
          this.serverObj,
          "otherReturnContent",
          this.volunteerTemp[0].userName
        )
      }
    },
    getDataList() {
      request({
        url: "/jjyl/admin/type/info/findList",
        method: "POST",
        data: {
          belongAddressLevel: 2,
          belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
          pageNo: 1,
          pageSize: 1000,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.options = res.content
          } else {
            this.options = []
          }
        }
      })
    },
    // 选择客户姓名
    inputClickName() {
      if (this.showTitle === "查看") return
      this.showAddStatus = true
      this.$refs.Customer.getDataList()
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {},
    oldCard() {
      this.showCard = !this.showCard
    },
    otherTelephone(val) {
      this.qtlxfs = val == "1"
    },
    isFranchisee(val) {
      this.franchisee = val === "是"
    },
    isOtherServePerson(val) {
      this.otherServePerson = val === "是"
    },
    isVolunteer(val) {
      this.volunteer = val === "是"
    },
    send() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          delete this.serverObj.franchisee
          delete this.serverObj.otherServePerson
          delete this.serverObj.volunteer
          this.serverObj.servetypename=this.serverObj.servetypename.toString()
          this.serverObj.serveproductName=this.serveproductName.toString()
          if (this.showTitle === "新增") {
            request({
              url: "/jjyl/servicePgd/info/addServicepgd",
              method: "POST",
              data: {
                ...this.serverObj,
                // otherservePersonID: null,
                // serveStation: null
              },
            }).then((res) => {
              if (res.code === 200) {
                this.closeWindow()
                this.$emit("updateList")
              }
            })
          } else if (this.showTitle === "编辑") {
            request({
              url: "/jjyl/servicePgd/info/updateServicepgd",
              method: "POST",
              data: {
                ...this.serverObj,
                // otherservePersonID: null,
                // serveStation: null
              },
            }).then((res) => {
              if (res.code === 200) {
                this.closeWindow()
                this.$emit("updateList")
                this.$message.success("编辑成功")
              }
            })
          } else {
            let states = "3"
            if (this.showTitle == "派发") {
              states = "1"
            } else if (this.showTitle == "处理") {
              states = "2"
            } else if (this.showTitle == "回访") {
              states = "3"
            } else if (this.showTitle == "作废") {
              states = "5"
            } else if (this.showTitle == "申请作废") {
              states = "4"
            }
            request({
              url: "/jjyl/servicePgd/info/Visit",
              method: "POST",
              data: {
                ...this.serverObj,
                states: states,
              },
            }).then((res) => {
              if (res.code == 200) {
                this.closeWindow()
                this.$emit("updateList")
              }
            })
          }
        } else {
          return false
        }
      })
    },
    //派发
    payOut() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          delete this.serverObj.franchisee
          delete this.serverObj.otherServePerson
          delete this.serverObj.volunteer
          if (this.serverObj.servePersonID) {
            request({
              url: "/jjyl/servicePgd/info/insertAndDistribute",
              method: "POST",
              data: {
                ...this.serverObj,
                // otherservePersonID: null,
                // serveStation: null,
                states: 1,
                belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
              },
            }).then((res) => {
              if (res.code === 200) {
                this.closeWindow()
                this.$message.success("派发成功")
                this.$emit("updateList")
                this.$emit("sucessSubmit")
              } else {
                this.$message.error("派发失败")
              }
            })
          } else {
            request({
              url: "/jjyl/servicePgd/info/Distribute",
              method: "POST",
              data: {
                ...this.serverObj,
                states: 1,
                idss: this.serverObj.idss,
              },
            }).then((res) => {
              if (res.code === 200) {
                this.$message.success("派发成功")
                this.closeWindow()
                this.$emit("updateList")
                this.$emit("sucessSubmit")
              } else {
                this.$message.error("派发失败")
              }
            })
          }
        } else {
          this.$message.error("请按照规则输入")
          return false
        }
      })
    },
    closeWindow() {
      this.$emit("update:showVisit", false)
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
      this.serverObj = {}
      this.serveproductName = []
      this.qtlxfs = false
      this.franchisee = false
      this.otherServePerson = false
      this.volunteer = false
      // 套餐类型应当选择的服务数量为0
      this.serviceNumber = 0
      this.display = 0
    },
  },
}
</script>
<style lang="less" scoped>
.dialog_container {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }
}

.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}

.add-ent {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.add-ent > div {
  width: 48%;
}

.add-title1 {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.add-title1 > div:first-child {
  width: 120px;
  text-align: right;
}

.add-title1 > div:nth-child(2) {
  width: calc(100% - 120px);
}

.visit-image {
  width: 60%;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.image-title {
  width: 178px;
  margin-top: 10px;
  text-align: center;
}

.cu-title1 {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.cu-title1 > div {
  width: 50%;
}

.cu-title2 {
  display: flex;
  align-items: center;
}

.cu-title2 > div:first-child {
  width: 80px;
  text-align: center;
}

.cu-title2 > div:nth-child(2) {
  width: calc(100% - 80px);
}

.cu-title3 {
  margin-left: 30px;
}
.addso{
  /deep/.el-form-item__content{
      width:75%
   }
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

</style>
